import {FlexSuiteStatistics} from '../../../../components/FlexSuiteStatistics'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introStats'>

export function IntroStats({introStats}: Props) {
  return <FlexSuiteStatistics stats={introStats} />
}
